function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCableContinuity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.89 37.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.26,36.65c1.46-1.84,2.07-4.94,1.8-7.76-.29-3.1-1.66-6-4.54-10.07C-1.47,11.81,1.82,5,4.78,1",
    transform: "translate(-0.29 0)",
    style: {
      fill: "white",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      strokeDasharray: "4,3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.27,1C10.31,5,7,11.81,12,18.82c2.54,3.57,3.79,5.91,4.29,8.76.58,3.3.1,7-1.55,9.07",
    transform: "translate(-0.29 0)",
    style: {
      fill: "white",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      strokeDasharray: "4,3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.53,37.62a13,13,0,0,0,2.24-5.54,13.67,13.67,0,0,0-1.21-7.79c-.1-.21-1-1.59-2.64-4.35S10.15,17.06,10,16.7A13.49,13.49,0,0,1,8.83,9.85,16.12,16.12,0,0,1,13.3,0H6.08a24.83,24.83,0,0,0-3.5,6.18,12.83,12.83,0,0,0-1,4.41A12.47,12.47,0,0,0,2,14.07a15.78,15.78,0,0,0,1.46,3.64c1.12,2,1.8,2.14,3,4.25a18.68,18.68,0,0,1,1.2,2.62,14.22,14.22,0,0,1,.89,8,12.48,12.48,0,0,1-2.32,5.09Z",
    transform: "translate(-0.29 0)",
    style: {
      fill: "#F1F3F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.76,11.74",
    transform: "translate(-0.29 0)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.10702078100953227px",
      strokeDasharray: "4.280831336975098,3.2106235027313232"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCableContinuity);
export default __webpack_public_path__ + "static/media/cable-continuity.2840d6b20e9dd5b1f9136e5255f13c2b.svg";
export { ForwardRef as ReactComponent };